export default "__VITE_ASSET__5efc3828__"